module.exports = __webpack_public_path__ + "img/TastingIQlogotype-withHSP.3f30b7cd.svg";